module.exports = __webpack_public_path__ + "img/Oiltanking_Belgium_Antwerp_Gas_Terminal_NV_Image_tanks1_1920px.e48852af.jpg";